const translateProvablyFairSettings = {
    en: {
        pfsItem1: "This game uses Provably Fair technology to determine game result. This tool gives you ability to change your seed and check fairness of the game.",
        pfsItem2: "What is Provably Fair",
        pfsItem3: "Client (your) seed:",
        pfsItem4: "Round result is determined form combination of server seed and first 3 bets of the round.",
        pfsItem5: "Random on every new game",
        pfsCurrent: "Current:",
        pfsItem6: "Enter Manually",
        pfsItem7: "Server seed SHA256:",
        pfsItem8: "You can check fairness of each bet from bets history",
        pfsChange: "CHANGE",
    },
    ru: {
        pfsItem1: "Эта игра использует технологию Provably Fair для определения результата игры. В этом окне вы можете изменить свой клиент сид и проверить справедливость игры",
        pfsItem2: "Что такое Provably Fair",
        pfsItem3: "Клиентский (ваш) сид:",
        pfsItem4: "Результат раунда определяется объединением сидов сервера и первых 3 ставок раунда",
        pfsItem5: "Случайно в каждой новой игре",
        pfsCurrent: "Текущий:",
        pfsItem6: "Введите вручную",
        pfsItem7: "Серверный сид SHA256:",
        pfsItem8: "Честность каждой ставки можно проверить в истории ставок",
        pfsChange: "ИЗМЕНИТЬ",
    },
    uz: {
        pfsItem1: "Bu oʻyinda oʻyin natijalarni aniqlash uchun Provably Fair texnologiyasidan foydalanadi. Bu vosita orqali siz oʻz sidingizni oʻzgartirishingiz va oʻyinning adolatli ekanligini tekshirishingiz mumkin.",
        pfsItem2: "Shubxasiz adolatlilik nima",
        pfsItem3: "Mijoz (sizning) sidi:",
        pfsItem4: "Raund natijasi server sidi va raundning dastlabki 3 ta garov tikishning kombinatsiyasi orqali aniqlanadi.",
        pfsItem5: "Har yangi oʻyinda tasodifiy",
        pfsCurrent: "Joriy:",
        pfsItem6: "Qo'lda kiriting!",
        pfsItem7: "Server sidi SHA256:",
        pfsItem8: "Siz pul tikish tarixidan har bir pul tikishning adolatli ekanligini tekshirishingiz mumkin",
        pfsChange: "O'ZGARTIRISH",
    }
}

export default translateProvablyFairSettings;